{
  "version": 1,
  "asset_id": "d41c97e1-a6e1-4908-99f9-e170a45c8a00",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/d41c97e1-a6e1-4908-99f9-e170a45c8a00/loc-cedar-park-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/d41c97e1-a6e1-4908-99f9-e170a45c8a00/loc-cedar-park-640.webp",
  "original_filename": "loc-cedar-park-640.webp",
  "size": 42564,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:20Z"
}
